export const createAction = <T>(name: T) => {
  const types = {
    INIT: name,
    START: `${name}_START`,
    STOP: `${name}_STOP`,
    SUCCESS: `${name}_SUCCESS`,
    FAIL: `${name}_FAIL`,
  } as const;

  const action = <P>(params?: P) => ({
    type: types.INIT,
    payload: params,
  });

  return { action, types };
};

export default createAction;
